import { render, staticRenderFns } from "./excavate_KM.vue?vue&type=template&id=1a10c5a1"
import script from "./excavate_KM.vue?vue&type=script&lang=js"
export * from "./excavate_KM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports